import SavingsMmaQuery from '@/app_gql/widgets/RedVentures/GetSavingsMMAQuery.gql';
import { GetData } from '@/app_lib/getData';
import { type RatesData, SavingsMmaResponse } from '../utils';
import type { RatesApiParameters } from './constants';

export async function getSavingsMma({
  depositAmount,
  page,
  accountType,
  pageSize,
  zip,
}: RatesApiParameters): Promise<RatesData[]> {
  const listingType = 'ALL';
  const ignoreBudget = false;
  const pid = 'myfi_fortune_api';

  const body = {
    zip,
    ...(page && { page }),
    ...(pageSize && { pageSize }),
    depositAmount,
    ignoreBudget,
    listingType,
    pid,
    prodType: typeof accountType === 'string' ? accountType.split(',') : accountType,
  };

  const data = await GetData.redVentures<SavingsMmaResponse>(SavingsMmaQuery, body);

  if (!data.success) {
    throw new Error(`HTTP Error: ${data}`);
  }
  const validatedData = SavingsMmaResponse.safeParse(data.value);
  if (!validatedData.success) {
    throw new Error(`Validation Error: ${validatedData.error}`);
  }
  return validatedData.data.savings_mma_rates;
}
